import { BodyText } from "@/components/ui/Text";
import { formatDate } from "date-fns";
import type { ChatMessage } from "../../types/chatMessageTypes";

interface MentalHealthQuestionnaireMessageProps {
  message: ChatMessage;
}

export const MentalHealthQuestionnaireMessage = ({
  message,
}: MentalHealthQuestionnaireMessageProps) => {
  const msgContent = `${message?.practitionerName || "System"} sent ${
    message?.questionnaireName
  } ${message.final ? "(completed)" : ""}`;

  return (
    <div className="flex flex-col items-center gap-1">
      <BodyText size="sm">{msgContent}</BodyText>
      <BodyText size="xs" textColor="tertiary">
        {formatDate(message.created, "MM/dd/yyyy h:mm a")}
      </BodyText>
    </div>
  );
};
